import { render, staticRenderFns } from "./DashboardHeads.vue?vue&type=template&id=1541ad28&scoped=true"
import script from "./DashboardHeads.vue?vue&type=script&lang=ts"
export * from "./DashboardHeads.vue?vue&type=script&lang=ts"
import style0 from "./DashboardHeads.vue?vue&type=style&index=0&id=1541ad28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1541ad28",
  null
  
)

export default component.exports